















































































  

import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import UpdateJobWorkerOfferRequest from '@/models/JobWorkerOffers/UpdateJobWorkerOfferRequest'
import JobWorkerOfferDto from '@/models/JobWorkerOffers/JobWorkerOfferDto';
import { JobDetailsModule } from '@/store/modules/jobDetails';
import { AppModule } from '@/store/modules/app';
import JobWorkerStatus from '@/models/JobWorkers/JobWorkerStatus';
import JobWorkerOfferStatus from '@/models/JobWorkerOffers/JobWorkerOfferStatus';

@Component({
    name: 'JobWorkerOfferEdit'
})
export default class extends GiganautVueDialog {

    @Prop({required: true})
    jobWorkerOffer: JobWorkerOfferDto;
    // @Prop({required: true})
    // jobWorkerStatus: JobWorkerStatus;
    request: UpdateJobWorkerOfferRequest = new UpdateJobWorkerOfferRequest();

    @Watch('dialog')
    async onDialogChanged(val: boolean, oldVal: boolean) {
        if (val) {
            this.request = new UpdateJobWorkerOfferRequest();
            this.request.annualSalary = this.jobWorkerOffer.annualSalary;
            //this.request.expiryDate = this.jobWorkerOffer.expiryDate;
            this.request.description = this.jobWorkerOffer.description;
        }
    }

    get loading() {
        return JobDetailsModule.loadingDialog;
    }

    get showEdit() {
		return this.jobWorkerOffer.status !== JobWorkerOfferStatus.Placed;
	}

    async save() {
        if (!(this.$refs.form as any).validate()) {
            return;
        }
        this.request.jobWorkerOfferId = this.jobWorkerOffer.id;
        this.request.updatedAt = this.jobWorkerOffer.updatedAt;
        await JobDetailsModule.editJobWorkerOffer(this.request);
        this.dialog = false;
    }
}
